import React from 'react';
import { Grid } from '@material-ui/core';
import { isStudent } from '../util/miscUtil';

export const militaryChecklistItemsV2 = [
  {
    key: 'militaryRecruiter',
    label: 'Meet with a military recruiter.',
    confirmKey: 'confirmMilitaryRecruiter',
    points: 8,
    due: 'During Phase 1',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'militaryASVAB',
    label: 'Take or retake ASVAB. ASVAB Score:',
    confirmKey: 'confirmMilitaryASVAB',
    points: 8,
    due: 'During Phase 1',
    minVersion: 2,
    maxVersion: 99,
    extra: (form, auth, asvab, classes) => (
      <Grid container direction="row" style={{ margin: '0 0 10px 60px' }}>
        <Grid item xs={12} sm={3} md={2} lg={2}>
          <label>ASVAB Score: {asvab}</label>
        </Grid>
        <Grid item xs={9} sm={8} md={10} lg={10}>
          <label className={classes.unprintedContent}>
            {isStudent(auth.roles) && <em>*Your ASVAB score can be entered on the Personal Information page.</em>}
          </label>
        </Grid>
      </Grid>
    ),
  },
  {
    key: 'militaryMEPS',
    label: 'Complete Military Enlistment Process Services (MEPS).',
    confirmKey: 'confirmMilitaryMEPS',
    points: 8,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'militaryEnlistmentContract',
    label: 'Sign the Military Enlistment contract.',
    confirmKey: 'confirmMilitaryEnlistmentContract',
    points: 8,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'militaryOath',
    label: 'Participate in the Oath of Enlistment ceremony.',
    confirmKey: 'confirmMilitaryOath',
    points: 8,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
];

export const militaryChecklistItems = [
  {
    key: 'militaryRecruiter',
    label: '49. Meet with a military recruiter.',
    confirmKey: 'confirmMilitaryRecruiter',
    points: 8,
    due: '1st Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'militaryASVAB',
    label: '50. Take or retake ASVAB.',
    confirmKey: 'confirmMilitaryASVAB',
    points: 8,
    due: '1st Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
    extra: (form, auth, asvabScore, classes) => (
      <Grid container direction="row" style={{ margin: '0 0 10px 60px' }}>
        <Grid item xs={12} sm={3} md={2} lg={2}>
          <label>ASVAB Score: {asvabScore}</label>
        </Grid>
        <Grid item xs={9} sm={8} md={10} lg={10}>
          <label className={classes.unprintedContent}>
            {isStudent(auth.roles) && <em>*Your ASVAB score can be entered on the Personal Information page.</em>}
          </label>
        </Grid>
      </Grid>
    ),
  },
  {
    key: 'militaryMEPS',
    label: '52. Complete Military Enlistment Process Services (MEPS).',
    confirmKey: 'confirmMilitaryMEPS',
    points: 8,
    due: 'April - May',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'militaryContract',
    label: '53. Sign the Military Enlistment contract.',
    confirmKey: 'confirmMilitaryContract',
    points: 8,
    due: 'April - May',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'militaryOathCeremony',
    label: '54. Participate in the Oath of Enlistment ceremony.',
    confirmKey: 'confirmMilitaryOathCeremony',
    points: 8,
    due: 'April - May',
    minVersion: 1,
    maxVersion: 1,
  },
  ...militaryChecklistItemsV2,
];
